import { useEffect, useState } from 'react'
import { Button, Modal, ModalHeader, ModalBody } from 'reactstrap'
import { IoIosClose } from 'react-icons/io'
import s from './EditProposalFileHtml.scss'
import { WordEditor, HtmlEditor } from 'components/ideal-core-ui'
import Select from 'react-select'

const pageTypes = [
  { value: 'a4', label: 'A4' },
  { value: 'letter', label: 'Letter' }
]

const EditProposalFileHtml = ({
  showEditFileModal,
  toggleEditFileModal,
  htmlContent,
  fileName,
  saveHtmlContent,
  isHtmlProposal,
  pageType: type,
  pages,
  categories
}) => {
  const [pageType, setPageType] = useState('a4')

  useEffect(() => {
    if (!type) return
    setPageType(type.toLowerCase())
  }, [type])

  return (
    <>
      <Modal
        keyboard={false}
        backdrop="static"
        isOpen={showEditFileModal}
        toggle={toggleEditFileModal}
        className={s.modal}
        size="xl"
        data-cy="edit_proposal_modal"
      >
        <ModalHeader toggle={toggleEditFileModal} className={s.modalHeader}>
          Edit Proposal
        </ModalHeader>
        <ModalBody className={s.modalBody}>
          <p className={s.title}>
            You are editing proposal file {fileName}.<br />
            Don&apos;t forget to save your edits before exiting this screen.
          </p>
          <div className={s.content}>
            {isHtmlProposal ? (
              <>
                <Select
                  placeholder="Page Type"
                  value={pageType.value ? pageType : pageTypes.find(t => t.value === pageType)}
                  onChange={value => setPageType(value.value)}
                  options={pageTypes}
                  className={s.layoutSelect}
                />
                <HtmlEditor
                  pageType={pageType}
                  pages={pages}
                  categories={categories || []}
                  actions={[
                    {
                      text: 'Save',
                      cb: (json, html) => {
                        saveHtmlContent(html, JSON.stringify(json), { pageType })
                      },
                      className: s.greenBtn
                    },
                    {
                      text: 'Cancel',
                      cb: toggleEditFileModal
                    }
                  ]}
                />
              </>
            ) : (
              <WordEditor
                template={htmlContent}
                saveActions={[
                  {
                    text: 'Save Edits',
                    cy: 'save_btn',
                    cb: (body, base64body) => {
                      saveHtmlContent(base64body, body)
                    },
                    className: s.greenBtn
                  }
                ]}
              />
            )}
          </div>
          {!isHtmlProposal && (
            <div className={s.actionBtns}>
              <Button color="secondary" onClick={toggleEditFileModal}>
                <IoIosClose className={s.cancel} />
                Cancel
              </Button>
            </div>
          )}
        </ModalBody>
      </Modal>
    </>
  )
}

export default EditProposalFileHtml
